import { Component, Inject, OnInit, Optional, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { SommaAssicurata } from 'src/app/models/somma-assicurata';
import { Polizza } from 'src/app/models/polizza';
import { SommaAssicurataService } from 'src/app/services/somma-assicurata.service';
import { BaseEditForm, EditFormConSuggerimenti } from 'src/app/shared/baseEditForm';
import { SuggerimentoService } from 'src/app/services/suggerimento.service';

@Component({
  selector: 'somma-assicurata-form',
  templateUrl: './form.component.html',
  styleUrls: ['./form.component.scss']
})
export class SommaAssicurataFormComponent extends EditFormConSuggerimenti implements OnInit {

  headingText = "Crea nuova somma assicurata";

  polizza: Polizza;

  form: FormGroup;

  sommaAssicurata: SommaAssicurata; //la sommaAssicurata che stiamo modificando

  constructor(
    private fb: FormBuilder,
    private toast: ToastrService,
    public dialogRef: MatDialogRef<SommaAssicurataFormComponent>,
    public sommaAssicurataService: SommaAssicurataService,
    suggerimentoService: SuggerimentoService,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: { sommaAssicurata: SommaAssicurata, polizza: Polizza },) {
    super(suggerimentoService);
    if (data) {
      if (data.sommaAssicurata?.id) {
        this.sommaAssicurata = data.sommaAssicurata;
        this.headingText = "Modifica somma assicurata " + this.sommaAssicurata.humanIdentifier;
      }
      if (data.polizza)
        this.polizza = data.polizza;
    }
  }


  async ngOnInit() {
    super.ngOnInit();
    this.form = this.fb.group({
      descrizione: [this.sommaAssicurata?.descrizione],
      valore: [this.sommaAssicurata?.valore],
      deroga_percentuale: [this.sommaAssicurata?.deroga_percentuale],
      polizza: [this.polizza],
    });
  }

  // Overwrite field with selected suggestion instead of concatenating
  addTextToControl(control_name: string, text: string) {
    const control = this.form?.controls?.[control_name];
    if (control) {
      control.patchValue(text);
    }
  }

}
